<template>
    <b-row>
        <b-col cols="12" class="text-center">
            <h2>{{ $t("perfil_sga.titulo_abonos") }}</h2>
            <p class="subtitle">{{ $t("perfil_sga.subtitulo_abonos") }}</p>
        </b-col>
        <b-col>
            <div v-if="loading" style="height: 200px">
                <LoaderComponent />
            </div>
            <div v-else-if="!perfiles.data || perfiles.data.length === 0" class="text-center pt-4 pb-5">
                <div >
                    <b-icon icon="bag-x" class="mb-3"/>
                    <h4>{{ $t("perfil_sga.sin_abonos") }}</h4>
                    <p>{{ $t("perfil_sga.mensaje_sin_abonos") }}</p>
                </div>
            </div>

            <div v-else class="row col-12 col-md-10 mx-auto px-0">
                <div 
                    class="w-100" 
                    v-for="(perfil, index) in perfiles.data" 
                    :key="index"
                >
                    <b-card class="border-0 mb-4" style="box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);">
                        <b-card-header class="card-header p-0 d-flex align-items-center">
                            <b-button 
                                class="w-100 d-flex text-dark border-0 bg-transparent py-3 pl-3 pr-1" 
                                v-b-toggle="'perfil-' + index"
                                @click="toggleCollapse(index)"
                            >
                                <div class="w-100 d-flex justify-content-between d-md-block">
                                    <div class="w-auto d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center pr-0 pr-md-4">
                                        <div class=" w-auto d-flex flex-column flex-md-row align-items-start align-items-md-center">
                                            <div class="border d-none d-lg-flex align-items-center justify-content-center p-1 mr-3 rounded-circle overflow-hidden mb-2 mb-md-0" style="width: 50px; height: 50px;">
                                                <b-icon icon="person" class="w-100 h-100"/>
                                            </div>
                                            <div>
                                                <div class="d-flex mb-2">
                                                    <p class="mb-0 mr-2"> {{ perfil.profile.name }}</p>
                                                    <p class="mb-0"> {{ perfil.profile.lastName }} </p>
                                                </div>
                                                <div class="d-flex mb-1 mb-md-0 font-weight-normal">
                                                    <b-icon icon="calendar-3" class="mr-2" />
                                                    <p class="mb-0"> {{ perfil.profile.birthday }} </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="d-flex font-weight-normal mb-2">
                                                <b-icon icon="card-text" class="mr-2" />
                                                <p class="mb-0"> {{ perfil.profile.identification.value }} </p>
                                            </div>
                                            <div class="d-flex font-weight-normal">
                                                <b-icon icon="telephone" class="mr-2" />
                                                <p class="mb-0"> +{{ perfil.profile.phone }} </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex align-items-start align-items-md-center justify-content-end" style="min-width: fit-content;">
                                    <p class="mb-0 d-none d-md-block" style=" font-size: 11px; font-weight: 400; min-width: 105px;"> {{ abrirAbonos[index]? 'Ocultar abonos' : 'Mostrar abonos' }} </p>
                                    <b-icon :icon="abrirAbonos[index] ? 'chevron-up' : 'chevron-down' " class="ml-0 ml-md-2"/>
                                </div>
                            </b-button>

                            <div class=" mb-auto mb-md-0 p-md-0" style="padding-top: 12px;">
                                <b-dropdown variant="link" toggle-class="border-0 bg-transparent p-0" no-caret right>
                                    <template #button-content>
                                        <b-icon icon="three-dots-vertical" class="border-0 mx-3 mx-md-2" style="width: 18px;"/>
                                    </template>

                                    <b-dropdown-item @click="openModalEditarPerfil(perfil.profile)">
                                        Editar datos
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>
                        </b-card-header>                        

                        <b-collapse :id="'perfil-' + index">
                            <b-card-body>
                                <b-col cols="12" v-for="(abono, abonoIndex) in perfil.abonos" :key="abonoIndex">
                                    <div class="p-3 w-100" v-if="abono?.id">
                                        <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
                                            <div class="d-flex align-items-center">
                                                <div class="border d-none d-lg-flex align-items-center justify-content-center p-2 rounded-circle overflow-hidden mb-2 mb-md-0" style="width: 50px; height: 50px;">
                                                    <b-icon icon="card-text" class="w-100 h-100" />
                                                </div>
                                                <div>
                                                    <p class="mb-0 ml-0 ml-lg-3 small"><strong>Nº Abonado:</strong> {{ abono?.n_abonado }} </p>
                                                    <p v-if="abono?.temporada" class="mb-0 ml-0 ml-lg-3 small text-muted">
                                                        {{ abono?.temporada }}
                                                    </p>
                                                </div>
                                            </div>
                                            <b-dropdown variant="link" toggle-class="border-0 bg-transparent p-0" no-caret right>
                                                <template #button-content>
                                                    <b-icon icon="three-dots-vertical" class="border-0 mx-3 mx-md-2" style="width: 18px;"/>
                                                </template>
                                                <b-dropdown-item @click="openModalPartidos(abono, perfil.profile)">
                                                    {{ $t('perfil.liberar_asiento') }}
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="transferir(abono)">
                                                    {{ $t("perfil_sga.transferir") }}
                                                </b-dropdown-item>                                                
                                                <b-dropdown-item @click="cambiarPin(abono)">
                                                    {{ $t('formularios.cambiar_pin') }}
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="verEventosCesion(abono)">
                                                    {{ $t('perfil_sga.ceder_entrada') }}
                                                </b-dropdown-item>
                                                <b-dropdown-item v-show="canShowRenewalButton(abono)" @click="openRenewalModal(abono)">
                                                    {{ $t('perfil_sga.renovar_abono') }}
                                                </b-dropdown-item>
                                                <b-dropdown-item v-show="canChangeSeat" @click="openCambioAsientoModal(abono)">
                                                    {{ $t('perfil_sga.cambiar_asiento') }}
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </div>
                                        <div class="w-100 small d-flex flex-column flex-md-row py-2">
                                            <div class="col-md-6 d-flex flex-column p-0">
                                                <div class="mb-2 px-0 d-flex flex-row align-items-start align-items-md-center">
                                                    <div class="d-flex align-items-center">
                                                        <b-icon icon="grid" class="mr-2" />
                                                        <strong class="mr-2 mr-md-1">{{ $t("perfil_sga.zona") }}:</strong>
                                                    </div>
                                                    <span> {{ abono?.asiento?.region?.nombre }} </span>
                                                </div>
                                                <div class="mb-2 px-0 d-flex flex-row align-items-start align-items-md-center">
                                                    <div class="d-flex align-items-center">
                                                        <b-icon icon="grid-3x3" class="mr-2" />
                                                        <strong class="mr-2 mr-md-1">{{ $t("perfil_sga.asiento") }}:</strong>
                                                    </div>
                                                    <span> {{ $t("perfil_sga.fila") }}: {{ abono?.asiento?.fila }}, {{ $t("perfil_sga.asiento") }}: {{ abono?.asiento?.asiento }} </span>
                                                </div>
                                            </div>
                                            <div class="col-md-6 d-flex flex-column p-0">
                                                <div class="mb-2 px-0 d-flex align-items-center">
                                                    <b-icon icon="currency-euro" class="mr-2" />
                                                    <strong class="mr-1">{{ $t("perfil_sga.precio") }}:</strong>
                                                    <span>{{ abono?.precio | formatear_precio }}</span>
                                                </div>
                                                <div class="mb-2 px-0 d-flex align-items-center">
                                                    <b-icon icon="calendar" class="mr-2" />
                                                    <strong class="mr-1">{{ $t("perfil_sga.fecha_alta") }}:</strong>
                                                    <span>{{ abono?.fecha_alta }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="font-weight-normal d-none d-md-flex flex-column flex-sm-row align-items-start align-items-md-center">
                                            <span :class="abono?.activo_temporada_actual == 'Active' ? 'text-success' : 'text-danger'">
                                                <i :class="abono?.activo_temporada_actual == 'Active' ? 'fas fa-check' : 'fas fa-times'"></i>
                                                {{ abono?.activo_temporada_actual == 'Active' ? $t("perfil_sga.activo") : $t("perfil_sga.inactivo") }}
                                            </span>
                                        </div>
                                        <div class="col-12 col-md-2 d-flex align-items-center flex-column flex-md-row mt-1 p-0">
                                            <div v-if="abono?.sga_apple_wallet_url" class="w-100 mb-2 mr-md-3">
                                                <button class="btn-wallet" @click="openWallet(abono.sga_apple_wallet_url)">
                                                    <img src="@/assets/icons/apple.svg" alt="apple icon" class="mr-2" style="width: 16px; height: 16px;"/>
                                                    <p class="mt-1 mb-0">wallet</p>
                                                </button>
                                            </div>
                                            <div v-if="abono?.sga_google_wallet_url" class="w-100 mb-2 mr-md-3">
                                                <button class="btn-wallet" @click="openWallet(abono.sga_google_wallet_url)">
                                                    <b-icon icon="google" class="mr-2" style="width: 15px; height: 15px;"/>
                                                    <p class="mt-1 mb-0">wallet</p>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="p-3 w-100">
                                        Error al recuperar la información del abono.
                                    </div>
                                    <hr v-if="abonoIndex + 1 != perfil.abonos.length"/>
                                </b-col>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
                <ModalComponent
                    v-if="abonoSeleccionado"
                    :name="'transferir-abono-' + abonoSeleccionado?.id"
                    :title="'Transferir abono Nº ' + abonoSeleccionado?.n_abonado"
                    @close="closeModalTransferir(false)"
                >
                    <b-row>
                        <b-col cols="12" class="mb-3">
                            <p><b>{{ $t('perfil_sga.aviso_permitir_transferir', { abono: teatro.texto_abono }) }}</b></p>
                            <p><b>{{ $t('perfil_sga.aviso_abono_transferido', { abono: teatro.texto_abono }) }}</b></p>
                            <p><b>{{ $t('perfil_sga.aviso_abono_otro_perfil', { abono: teatro.texto_abono }) }}</b></p>
                        </b-col>
                        <b-col cols="12" md="6" class="mb-3">
                            <div class="custom-control custom-checkbox">
                                <input
                                    class="custom-control-input"
                                    type="checkbox"
                                    v-model="cambiar_numero_suscriptor"
                                    id="cambiar_numero_suscriptor"
                                    name="cambiar_numero_suscriptor"
                                />
                                <label class="custom-control-label d-flex align-items-center" for="cambiar_numero_suscriptor">
                                    {{ $t('perfil_sga.cambiar_numero_abonado', { abonado: teatro.texto_abonado }) }}
                                    <InfoToolTip
                                        class="ml-1"
                                        info="Al transferir el abono, el número de abonado actual se modificará y se asignará uno nuevo al nuevo usuario."
                                    />
                                </label>
                            </div>
                        </b-col>
                        <b-col cols="12" md="6" class="mb-3">
                            <div class="custom-control custom-checkbox">
                                <input
                                    class="custom-control-input"
                                    type="checkbox"
                                    v-model="cambiar_fecha_antiguedad"
                                    id="cambiar_fecha_antiguedad"
                                    name="cambiar_fecha_antiguedad"
                                />
                                <label class="custom-control-label d-flex align-items-center" for="cambiar_fecha_antiguedad">
                                    {{ $t('perfil_sga.cambiar_fecha_antiguedad') }}
                                    <InfoToolTip
                                        class="ml-1"
                                        info="La fecha de antigüedad del abonado se actualizará a la fecha actual al realizar la transferencia."
                                    />
                                </label>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                                <DatosAbonoSGAComponent
                                    :datosAbonosLocal="nuevoAbono"
                                    :index="0"
                                    :generos="generos"
                                />
                                <button type="submit" name="button" class="button effect-button" :disabled="loading">
                                    <span>{{ $t('perfil_sga.transferir') }}</span>
                                </button>
                            </ValidationObserver>
                        </b-col>
                    </b-row>
                </ModalComponent>
            </div>
        </b-col>
        <CambioPin 
            :loading="changingPin"
            :showIdAndOldPin ="false"
            @cambiarPin="procesarCambioPin"
            @close="closeModal"
        />

        <PartidosModal
            v-if="abonoSeleccionado && perfilSeleccionado"
            :abono="abonoSeleccionado"
            :perfil="perfilSeleccionado"
            @close="abonoSeleccionado = null"
        />
        <EditarPerfil
            v-if="perfilSeleccionado"
            :perfil="perfilSeleccionado"
            @close="(updated) => { if (updated) { getAbonos(); } perfilSeleccionado = null; }"
        />

        <CesionesModal
            :abonadoId="abonadoCesion"
            @close="closeModalEventosCesion()"
            v-if="showEventosCesionModal"
        />
        <RenovacionSgaModal
            v-if="showRenovacionModal"
            :abonado_id="selectedAbonadoForRenewal"
            :renewal_periods="selectedRenewalInfo?.renewal_periods || []"
            :sales_category_id="selectedRenewalInfo?.sales_category_id"
            :promotions="selectedRenewalInfo?.promotions || []"
            :discounts="selectedRenewalInfo?.discounts || []"
            :gastos_gestion="selectedRenewalInfo?.gastos_gestion || 0"
            :status="selectedRenewalInfo?.status ?? null"
            @close="closeRenovacionModal"
        />
        <CambioAsientoSgaModal
            v-if="showCambioAsientoModal"
            :key="selectedAbonadoForCambioAsiento"
            :abonado-id="selectedAbonadoForCambioAsiento"
            :sga-event-id="selectedAbonoEventId"
            :abono="selectedAbonoForCambio"
            @close="closeCambioAsientoModal"
            @success="handleCambioAsientoSuccess"
        />
    </b-row>
</template>

<script>
    import InfoToolTip from '@/components/common/InfoToolTip';
    import LoaderComponent from "@/components/preloader/LoaderComponent";
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import DatosAbonoSGAComponent from "../../abonos/sga/components/DatosAbonoSGAComponent";
    import CambioPin from '@/views/frontend/mi_abono/modals/CambioPin';
    import PartidosModal from "./abono/PartidosModal.vue";
    import { validate } from 'vee-validate';
    import EditarPerfil from "./perfil/EditarPerfil.vue";
    import CesionesModal from "./abono/CesionesModal.vue";
    import RenovacionSgaModal from "./RenovacionSgaModal.vue";
    import CambioAsientoSgaModal from "./CambioAsientoSgaModal.vue";

    export default {
        data() {
            return {
                perfiles: [],
                updateEvents : true,
                loading: false,
                abrirAbonos: {},
                current_page: 1,
                options: false,
                changingPin: false,
                selectedAbono: null,
                abonoSeleccionado: null,
                perfilSeleccionado: null,
                nuevoAbono: {
                    name: '',
                    lastName: '',
                    gender: '',
                    gender_object: null,
                    identification: {
                        type: '',
                        value: ''
                    },
                    address: {
                        country: '',
                        state: '',
                        city: '',
                        zipCode: '',
                        streetLine1: ''
                    },
                    birthday: '',
                    email: '',
                    email_confirm: '',
                    phone: null,
                    isValidNumber: false,
                    error_telefono: false
                },
                cambiar_numero_suscriptor: false,
                cambiar_fecha_antiguedad: false,
                showEventosCesionModal: false,
                abonadoCesion: null,
                showRenovacionModal: false,
                selectedAbonadoForRenewal: null,
                selectedRenewalInfo: null,
                showCambioAsientoModal: false,
                selectedAbonadoForCambioAsiento: null,
                selectedAbonoEventId: null,
                selectedAbonoForCambio: null
            };
        },
        mounted() {
            this.getAbonos();
        },
        methods: {
            getAbonos() {
                this.loading = true;
                const params = {
                    filters : {
                        page: this.current_page,
                    },
                }

                this.$store.dispatch(this.config.getVuexAlias("front.perfil.abonos.sga"), params).then(res => {
                    this.perfiles = res.data;
                })
                    .catch(() => {
                        this.$toast.error(this.$t('perfil_sga.error_obtener_abono'));
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            toggleCollapse(id) {
                const wasOpen = this.abrirAbonos[id];
                this.$set(this.abrirAbonos, id, !wasOpen);

                // When opening, fetch renewal info for all abonos in this profile
                if (!wasOpen && this.perfiles?.data?.[id]?.abonos) {
                    this.perfiles.data[id].abonos.forEach(abono => {
                        if (abono?.id) {
                            this.fetchRenewalInfo(abono);
                        }
                    });
                }
            },
            setPage(page) {
                this.current_page = page;
            },
            openWallet(url) {
                if (url) {
                    window.open(url, '_blank');
                    this.$toast.success(this.$t('perfil_sga.abono_descargado'));
                }
            },

            cambiarPin(abono) {
                this.selectedAbono = abono;
                this.$modal.show('cambioPin');
            },

            async procesarCambioPin(data){
                this.changingPin = true;

                const validation = await validate(data.pin_new, 'alpha_num');
                if (!validation.valid) {
                    this.$toast.error(this.$t('perfil_sga.error_pin_caracteres'));
                    this.changingPin = false;
                    return;
                }

                const params = {
                    abono_id: this.selectedAbono.id,
                    newPin: data.pin_new
                }

                this.$store.dispatch(this.config.getVuexAlias("front.perfil.abonos.cambiar-pin"), params)
                    .then(res => { 
                        this.$toast.success(this.$t('perfil_sga.pin_cambiado_correctamente'));
                        this.closeModal();
                    })
                    .catch(error => {
                        let mensajeError = this.$t('perfil_sga.error_cambiar_pin');
                        
                        if (error.response && error.response.data) {
                            const errorData = error.response.data;
                            
                            if (errorData.errors && Array.isArray(errorData.errors) && errorData.errors.length > 0) {
                                mensajeError = errorData.errors[0].message;
                            }
                        }
                        
                        this.$toast.error(mensajeError);
                    })
                    .finally(() => {
                        this.changingPin = false;
                    });
            },

            closeModal() {
                this.$modal.hide('cambioPin');
                this.selectedAbono = null;
            },
            transferir(abono) {
                this.abonoSeleccionado = abono;

                this.$nextTick(() => {
                    this.$modal.show('transferir-abono-' + abono.id);
                });
            },
            closeModalTransferir(transferido) {
                if (transferido) {
                    this.getAbonos();
                }

                this.$modal.hide('transferir-abono-' + this.abonoSeleccionado?.id);
            },
            submit() {
                const isValid = this.$refs.observer.validate();

                if (isValid) {
                    this.transferirAbono();
                }
            },
            transferirAbono() {
                this.loading = true;

                const params = {
                    filters : {
                        cambiar_numero_suscriptor: this.cambiar_numero_suscriptor ? 1 : 0,
                        cambiar_fecha_antiguedad: this.cambiar_fecha_antiguedad ? 1 : 0,
                    },
                    profile_new: this.nuevoAbono,
                    abonado_id: this.abonoSeleccionado.id
                }

                this.$store.dispatch(this.config.getVuexAlias("front.perfil.abono.sga.transferir"), params).then(res => {
                    this.$toast.success(this.$t('perfil_sga.abono_transferido_correctamente'));
                    this.getAbonos();

                }).catch(e => {
                    console.error(e);
                }).finally(() => {
                    this.loading = false;
                });
            },

            verEventosCesion(abono) {
                this.abonadoCesion = abono.id;
                this.showEventosCesionModal = true;
                
                this.$nextTick(() => {
                    this.$modal.show('eventos-cesion-modal');
                });
            },            
            closeModalEventosCesion() {
                this.showEventosCesionModal = false;
                this.eventosCesion = [];
                this.$modal.hide('eventos-cesion-modal');
            },
            openModalPartidos(abono, perfil) {
                this.abonoSeleccionado = abono;
                this.perfilSeleccionado = perfil;
                this.$nextTick(() => {
                    this.$modal.show('partidosModal');
                });

            },
            openModalEditarPerfil(perfil) {
                this.perfilSeleccionado = perfil;
                this.$nextTick(() => {
                    this.$modal.show('perfilModal');
                });
            },
            fetchRenewalInfo(abono) {
                // Skip when the manager has renewal disabled for this teatro —
                // the option is hidden anyway and the call would just waste a
                // round-trip to the backend. The flag comes from the settings
                // request and may arrive as boolean true or numeric 1.
                if (!this.manager?.renovar_abono) return;

                // Guard: skip if already fetched
                if (abono._renewalInfo) {
                    return;
                }

                this.$set(abono, '_renewalLoading', true);

                this.$store.dispatch(this.config.getVuexAlias('sga.profile.abonos.renewal-info'), { abonado_id: abono.id })
                    .then(res => {
                        this.$set(abono, '_renewalInfo', res.data?.data || res.data || {});
                    })
                    .catch(error => {
                        if (process.env.NODE_ENV === 'development') {
                            console.error('Error fetching renewal info:', error);
                        }
                        this.$set(abono, '_renewalInfo', { can_renew: false });
                    })
                    .finally(() => {
                        this.$set(abono, '_renewalLoading', false);
                    });
            },
            canShowRenewalButton(abono) {
                // The 'renovar_abono' flag from the manager settings gates the
                // option globally per teatro. The flag may come as boolean
                // true or numeric 1 (loose settings payload). The per-abonado
                // info still has to report can_renew + at least one renewal
                // period — unless status.value === 2 (blocked), in which
                // case we still surface the option so the user can read the
                // blocked message instead.
                if (!this.manager?.renovar_abono) return false;

                const info = abono._renewalInfo;
                if (info?.status?.value === 2) return true;

                return (
                    info?.can_renew === true &&
                    Array.isArray(info?.renewal_periods) &&
                    info.renewal_periods.length > 0
                );
            },
            openRenewalModal(abono) {
                const info = abono._renewalInfo;
                this.selectedAbonadoForRenewal = String(abono.id);
                this.selectedRenewalInfo = info;
                this.showRenovacionModal = true;
                this.$nextTick(() => {
                    this.$modal.show('renovacion-sga-modal');
                });
            },
            closeRenovacionModal() {
                this.$modal.hide('renovacion-sga-modal');
                this.showRenovacionModal = false;
                this.selectedAbonadoForRenewal = null;
                this.selectedRenewalInfo = null;
            },
            openCambioAsientoModal(abono) {
                this.selectedAbonadoForCambioAsiento = String(abono.id);
                this.selectedAbonoEventId = this.$store.getters.getListaAbonados?.sga_event_id || null;
                this.selectedAbonoForCambio = abono;
                this.showCambioAsientoModal = true;
                this.$nextTick(() => {
                    this.$modal.show('cambio-asiento-sga-modal-' + abono.id);
                });
            },
            closeCambioAsientoModal() {
                this.$modal.hide('cambio-asiento-sga-modal-' + this.selectedAbonadoForCambioAsiento);
                this.showCambioAsientoModal = false;
                this.selectedAbonadoForCambioAsiento = null;
                this.selectedAbonoEventId = null;
                this.selectedAbonoForCambio = null;
            },
            handleCambioAsientoSuccess(data) {
                this.$toast.success(this.$t('perfil_sga.cambio_exitoso'));
                this.getAbonos();
            }
        },
        watch: {
            current_page() {
                this.getAbonos();
            },
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            listaAbonados() {
                return this.$store.getters.getListaAbonados;
            },
            canChangeSeat() {
                // The 'seat_change_active' flag from lista_abonados in the
                // settings request gates the seat change option. The flag
                // may come as boolean true or numeric 1 (loose settings
                // payload).
                return !!this.listaAbonados?.seat_change_active;
            },
            generos() {
                return this.$store.getters.getGeneros;
            }
        },
        components: {
            LoaderComponent, CambioPin, PartidosModal,
            InfoToolTip, ModalComponent, DatosAbonoSGAComponent,
            EditarPerfil, CesionesModal, RenovacionSgaModal,
            CambioAsientoSgaModal
        },
    }
</script>

<style scoped>
.btn-wallet {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 4px 12px;
    background-color: #ffffff;
    color: #343a40;
    border: none;
    border-radius: 6px;
    font-size: 12px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    transition: all 0.25s ease-in-out;
    cursor: pointer;
    text-transform: uppercase;
}

.btn-wallet:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
    transform: translateY(-1px);
    scale: 1.05;
}
.card-body {
    padding: 0 !important;
}

::v-deep .dropdown-toggle .bi-three-dots-vertical {
    color: #000;
}

::v-deep .dropdown-toggle .bi-three-dots-vertical:hover {
    color: gray ;
}

::v-deep .dropdown-item {

    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    min-height: 40px;
    padding-left: 1rem !important;;
}


</style>
